import "core-js/modules/es.array.push.js";
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, vModelDynamic as _vModelDynamic, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/image/passeyes.png';
import _imports_1 from '../../assets/image/passeyesopn.png';
const _withScopeId = n => (_pushScopeId("data-v-067bdd8c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "tk-from"
};
const _hoisted_2 = {
  class: "tk-field-icon"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  class: "tk-field-input"
};
const _hoisted_5 = ["type", "onUpdate:modelValue", "placeholder"];
const _hoisted_6 = ["onClick"];
const _hoisted_7 = {
  key: 0,
  src: _imports_0,
  alt: ""
};
const _hoisted_8 = {
  key: 1,
  src: _imports_1,
  alt: ""
};
const _hoisted_9 = ["src"];
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tk-from-field bottom"
}, [/*#__PURE__*/_createElementVNode("button", {
  type: "submit"
}, "注册")], -1));
import { register, captcha, loginChat } from '@/utils/https/register';
import Dialog from '@/components/mode/message.js';
import { getUserInfo } from '@/utils/https/me';

import { useRouter } from 'vue-router';
import { reactive, toRefs, onBeforeMount } from 'vue';
export default {
  __name: 'register',
  setup(__props) {
    let router = useRouter();
    let data = reactive({
      from: [{
        type: 'text',
        name: 'username',
        placeholder: '请输入用户名',
        value: '',
        icon: require('@/assets/image/user.png')
      }, {
        type: 'password',
        name: 'password',
        placeholder: '请输入密码',
        value: '',
        icon: require('@/assets/image/password.png'),
        type_c: 'password'
      }, {
        type: 'password',
        name: 'password_confirmation',
        placeholder: '请再次输入密码',
        value: '',
        icon: require('@/assets/image/password.png'),
        type_c: 'password'
      }, {
        type: 'text',
        name: 'code',
        placeholder: '请输入验证码',
        value: '',
        icon: require('@/assets/image/code.png'),
        type_c: 'code'
      }],
      lookeyes: true,
      froms: {
        account_name: '',
        password: '',
        password_confirmation: '',
        captcha: '',
        key: '',
        device: 'h5'
      },
      show: false,
      codeImg: '',
      message: ''
    });
    let {
      show,
      from,
      codeImg,
      message,
      froms
    } = toRefs(data);
    onBeforeMount(() => {
      captchas();
    });
    let registers = datas => {
      captchas();
      register(datas).then(res => {
        if (res.status != '400') {
          let data = res.data.data;
          Dialog(res.data.message);
          localStorage.setItem('Authorization', `${data.token_type} ${data.token}`);
          loginChats();
          getUserInfos();
          router.push({
            path: '/index'
          });
        } else {
          captchas();
          Dialog(res.data.message);
        }
      });
    };
    let loginChats = () => {
      loginChat().then(res => {
        let chat = res.data.data.token;
        localStorage.setItem('chatToken', chat);
      });
    };
    let getUserInfos = () => {
      getUserInfo().then(res => {
        if (res.status != 500) {
          let datas = res.data.data;
          data.userInfo = datas;
          localStorage.setItem('usetInfo', JSON.stringify(datas));
        } else {
          data.userInfo = '';
        }
      });
    };
    let captchas = () => {
      //请求验证码
      captcha().then(res => {
        let datas = res.data.data;
        data.froms.key = datas.key;
        data.codeImg = datas.img;
      });
    };
    let codeImgFun = () => {
      captchas();
    };
    let onSubmit = e => {
      e.preventDefault();
      data.from.forEach(item => {
        if (item.name == 'username') {
          data.froms.account_name = item.value;
        } else if (item.name == 'password') {
          data.froms.password = item.value;
        } else if (item.name == 'password_confirmation') {
          data.froms.password_confirmation = item.value;
        } else if (item.name == 'code') {
          data.froms.captcha = item.value;
        }
      });
      if (data.froms.account_name == '') {
        Dialog('用户名不能为空');
      }
      // else if( str.test(data.froms.account_name)){
      //     Dialog('用户名只支持英文字母和数字')
      // }
      else if (data.froms.password == '') {
        Dialog('密码不能为空');
      } else if (data.froms.password_confirmation == '') {
        Dialog('密码不能为空');
      } else if (data.froms.password_confirmation != data.froms.password) {
        Dialog('两次密码不一致');
      } else if (data.froms.captcha == '') {
        Dialog('验证码不能为空');
      } else {
        registers(data.froms);
      }
    };
    let lookPassword = index => {
      data.lookeyes = !data.lookeyes;
      if (data.lookeyes) {
        data.from[index].type = 'password';
      } else {
        data.from[index].type = 'text';
      }
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("form", {
        onSubmit: _cache[1] || (_cache[1] = (...args) => _unref(onSubmit) && _unref(onSubmit)(...args))
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(from), (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: "tk-from-field flex-between",
          key: index
        }, [_createElementVNode("div", _hoisted_2, [_createElementVNode("img", {
          class: "imgs",
          src: item.icon,
          alt: ""
        }, null, 8, _hoisted_3)]), _createElementVNode("div", _hoisted_4, [_withDirectives(_createElementVNode("input", {
          type: item.type,
          "onUpdate:modelValue": $event => item.value = $event,
          placeholder: item.placeholder
        }, null, 8, _hoisted_5), [[_vModelDynamic, item.value]])]), item.type_c == 'password' ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "tk-field-tips",
          onClick: $event => _unref(lookPassword)(index)
        }, [_unref(data).lookeyes ? (_openBlock(), _createElementBlock("img", _hoisted_7)) : (_openBlock(), _createElementBlock("img", _hoisted_8))], 8, _hoisted_6)) : _createCommentVNode("", true), item.type_c == 'code' ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "tk-field-code",
          onClick: _cache[0] || (_cache[0] = (...args) => _unref(codeImgFun) && _unref(codeImgFun)(...args))
        }, [_createElementVNode("img", {
          src: _unref(codeImg),
          alt: ""
        }, null, 8, _hoisted_9)])) : _createCommentVNode("", true)]);
      }), 128)), _hoisted_10], 32)]);
    };
  }
};